import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import _createForOfIteratorHelper from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import store from "@/store";
export function findTreeItemWithPath(path, tree) {
  var _iterator = _createForOfIteratorHelper(tree),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var t = _step.value;
      if (t.path.toLocaleLowerCase() === path) {
        return t.children;
      } else if (t.children && t.children.length > 0) {
        var children = findTreeItemWithPath(path, t.children);
        if (children) {
          return children;
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return false;
}
export function isPermission(code, permissionTree) {
  // return (
  //   permissionTree &&
  //   permissionTree.some(t => {
  //     if (t.type===2 && t.code.toLocaleLowerCase() === code.toLocaleLowerCase()) {
  //       return true
  //     } else {
  //       return t.children && t.children.length && isPermission(code, t.children)
  //     }
  //   })
  // )
  return permissionTree && permissionTree.some(function (t) {
    return t.type !== 1 && t.code.toLocaleLowerCase() === code.toLocaleLowerCase();
  });
}

// 缓存菜单按钮权限树
var PermissionChildrenMap = new Map();

/**
 * @param {String|Array} value 权限编码
 * @param {String} path 当前路由路径
 * @returns {Boolean}
 */
export default function checkPermission(value, routePath) {
  if (!value) {
    throw new Error("need permission value ! type permission code ");
  }
  if (!routePath) {
    if (this && this.$route) {
      routePath = this.$route.path;
    } else {
      throw new Error("need routePath value ! like checkPermission('value','routePath') or checkPermission.call(this,'value') ");
    }
  }
  var path = routePath.toLocaleLowerCase();
  var permissionTree = store.getters.permission_tree_menus;
  var permissionChildren = null;
  if (PermissionChildrenMap.has(path)) {
    permissionChildren = PermissionChildrenMap.get(path);
  } else {
    permissionChildren = findTreeItemWithPath(path, permissionTree);
    permissionChildren && PermissionChildrenMap.set(path, permissionChildren);
  }
  if (permissionChildren && permissionChildren.length > 0) {
    var permissionValue = value instanceof Array ? value : [value];
    var hasPermission = permissionValue.some(function (val) {
      return isPermission(val, permissionChildren);
    });
    return hasPermission;
  } else {
    return false;
  }
}